import { Link } from 'react-router-dom';
import Button from './Button';
import Spacer from './Spacer';
import './Header.scss';
import Wrapper from '../base/Wrapper';
import UserInfo from './UserInfo';

const Header = ({ user, onLogout }) => {
  return (
    <>
      <div className="Header">
        <Wrapper>
          <Link to="/" className="logo">
            REACTERS
          </Link>
          {user ? (
            <div className="right">
              <UserInfo>{user.username}</UserInfo>
              <Button onClick={onLogout}>로그아웃</Button>
            </div>
          ) : (
            <div className="right">
              <Button to="/login">로그인</Button>
            </div>
          )}
        </Wrapper>
      </div>
      <Spacer />
    </>
  );
};

export default Header;
